import { safeJsonParse } from './recruitUtils';

export const DEFAULT_SORT_ITEM = [{ sort: '전임', content: '' }];
export const DEFAULT_WORK_TIME_SUN = [
  { sort: '전임', startHour: '09', startMinute: '00', endHour: '16', endMinute: '00' },
];
export const DEFAULT_WORK_TIME_WEEK = [
  { sort: '전임', startHour: '09', startMinute: '00', endHour: '17', endMinute: '00', day: '평일' },
];
export const DEFAULT_PAY = [{ sort: '전임', paySort: '월', selectCost: '', inputCost: '' }];
export const DEFAULT_APPLYTIME = { startDay: '', endDay: '', daySort: '' };
export const DEFAULT_INQUIRY = { inquiryName: '', email: '', phone: '' };

export type ParsedRecruitFormRow = {
  userAccount: string;
  source: string;
  link: string;
  title: string;
  writer: string;
  date: string;
  church: string;
  religiousbody: string;
  location: string;
  locationDetail: string;
  address: string;
  mainpastor: string;
  homepage: string;
  sort: string;
  recruitNum: string;
  applyhow: string;
  etcNotice: string;
  customInput: string;
  existingChurchLogo: string;
  school: typeof DEFAULT_SORT_ITEM;
  career: typeof DEFAULT_SORT_ITEM;
  applydoc: typeof DEFAULT_SORT_ITEM;
  applytime: typeof DEFAULT_APPLYTIME;
  inquiry: typeof DEFAULT_INQUIRY;
  notifiApprove: boolean;
  personalInfo: boolean;
  part: typeof DEFAULT_SORT_ITEM;
  partDetail: typeof DEFAULT_SORT_ITEM;
  workday: typeof DEFAULT_SORT_ITEM;
  workTimeSunDay: typeof DEFAULT_WORK_TIME_SUN;
  workTimeWeek: typeof DEFAULT_WORK_TIME_WEEK;
  dawnPray: typeof DEFAULT_SORT_ITEM;
  pay: typeof DEFAULT_PAY;
  welfare: typeof DEFAULT_SORT_ITEM;
  insurance: typeof DEFAULT_SORT_ITEM;
  severance: typeof DEFAULT_SORT_ITEM;
};

export function parseRecruitRowForForm(row: Record<string, unknown>): ParsedRecruitFormRow {
  return {
    userAccount: String(row.userAccount || ''),
    source: String(row.source || ''),
    link: String(row.link || ''),
    title: String(row.title || ''),
    writer: String(row.writer || ''),
    date: String(row.date || ''),
    church: String(row.church || ''),
    religiousbody: String(row.religiousbody || ''),
    location: String(row.location || ''),
    locationDetail: String(row.locationDetail || ''),
    address: String(row.address || ''),
    mainpastor: String(row.mainPastor || row.mainpastor || ''),
    homepage: String(row.homepage || ''),
    sort: String(row.sort || ''),
    recruitNum: String(row.recruitNum || ''),
    applyhow: String(row.applyhow || ''),
    etcNotice: String(row.etcNotice || ''),
    customInput: String(row.customInput || ''),
    existingChurchLogo: String(row.churchLogo || ''),
    school: safeJsonParse(row.school, DEFAULT_SORT_ITEM),
    career: safeJsonParse(row.career, DEFAULT_SORT_ITEM),
    applydoc: safeJsonParse(row.applydoc, DEFAULT_SORT_ITEM),
    applytime: safeJsonParse(row.applytime, DEFAULT_APPLYTIME),
    inquiry: safeJsonParse(row.inquiry, DEFAULT_INQUIRY),
    notifiApprove: Boolean(Number(row.notifiApprove)),
    personalInfo: Boolean(Number(row.personalInfo)),
    part: safeJsonParse(row.part, DEFAULT_SORT_ITEM),
    partDetail: safeJsonParse(row.partDetail, DEFAULT_SORT_ITEM),
    workday: safeJsonParse(row.workday, DEFAULT_SORT_ITEM),
    workTimeSunDay: safeJsonParse(row.workTimeSunDay, DEFAULT_WORK_TIME_SUN),
    workTimeWeek: safeJsonParse(row.workTimeWeek, DEFAULT_WORK_TIME_WEEK),
    dawnPray: safeJsonParse(row.dawnPray, DEFAULT_SORT_ITEM),
    pay: safeJsonParse(row.pay, DEFAULT_PAY),
    welfare: safeJsonParse(row.welfare, DEFAULT_SORT_ITEM),
    insurance: safeJsonParse(row.insurance, DEFAULT_SORT_ITEM),
    severance: safeJsonParse(row.severance, DEFAULT_SORT_ITEM),
  };
}
